/**
 * Datos que deben identificar al titular real de la web.
 *
 * IMPORTANTE: completa los campos vacíos antes de publicar las páginas legales.
 * Se mantienen en un único archivo para evitar discrepancias entre documentos.
 */
export const legalConfig = {
  tradeName: "MesVida Fitness",
  legalStatus: "Empresario individual (autónomo)",
  legalName: "Juan José Lucas Almeida",
  taxId: "44781716A",
  registeredAddress:
    "Carrer Anoia 29-31, Sant Andreu de la Barca, Barcelona, España",
  registryDetails: "No aplicable (empresario individual/autónomo)",
  contactEmail: "info@mesvida.com",
  privacyEmail: "info@mesvida.com",
  website: "https://mesvida.com",
  hostingProvider: "BanaHosting",
  hostingRegion: "Europa",
  emailProvider: "BanaHosting",
  lastUpdated: "2 de octubre de 2026",
};

export const pendingLegalValue = (value, label) =>
  value || `[PENDIENTE: ${label}]`;
